/* tslint:disable */
/* eslint-disable */
/**
 * PaGu Api
 * Gutschrifterstellung API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PartnerByFilterRequest } from '../models';
// @ts-ignore
import type { PartnerDtoSearchResponse } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
// @ts-ignore
import type { SpecialCaseDtoPagedListResponse } from '../models';
/**
 * PartnerApi - axios parameter creator
 * @export
 */
export const PartnerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerGemasPartnerIdGet: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('apiV1PartnerGemasPartnerIdGet', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partner/gemas/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerPartnerIdDelete: async (partnerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('apiV1PartnerPartnerIdDelete', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partner/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerPost: async (body?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PartnerByFilterRequest} [partnerByFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSpecialcasesPost: async (partnerByFilterRequest?: PartnerByFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/partner/specialcases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partnerByFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerApi - functional programming interface
 * @export
 */
export const PartnerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PartnerGemasPartnerIdGet(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerDtoSearchResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PartnerGemasPartnerIdGet(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerApi.apiV1PartnerGemasPartnerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PartnerPartnerIdDelete(partnerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PartnerPartnerIdDelete(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerApi.apiV1PartnerPartnerIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PartnerPost(body?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PartnerPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerApi.apiV1PartnerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PartnerByFilterRequest} [partnerByFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PartnerSpecialcasesPost(partnerByFilterRequest?: PartnerByFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialCaseDtoPagedListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PartnerSpecialcasesPost(partnerByFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerApi.apiV1PartnerSpecialcasesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnerApi - factory interface
 * @export
 */
export const PartnerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerGemasPartnerIdGet(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PartnerDtoSearchResponse>> {
            return localVarFp.apiV1PartnerGemasPartnerIdGet(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerPartnerIdDelete(partnerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV1PartnerPartnerIdDelete(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerPost(body?: number, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV1PartnerPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PartnerByFilterRequest} [partnerByFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PartnerSpecialcasesPost(partnerByFilterRequest?: PartnerByFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpecialCaseDtoPagedListResponse> {
            return localVarFp.apiV1PartnerSpecialcasesPost(partnerByFilterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartnerApi - interface
 * @export
 * @interface PartnerApi
 */
export interface PartnerApiInterface {
    /**
     * 
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApiInterface
     */
    apiV1PartnerGemasPartnerIdGet(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PartnerDtoSearchResponse>>;

    /**
     * 
     * @param {number} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApiInterface
     */
    apiV1PartnerPartnerIdDelete(partnerId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApiInterface
     */
    apiV1PartnerPost(body?: number, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @param {PartnerByFilterRequest} [partnerByFilterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApiInterface
     */
    apiV1PartnerSpecialcasesPost(partnerByFilterRequest?: PartnerByFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpecialCaseDtoPagedListResponse>;

}

/**
 * PartnerApi - object-oriented interface
 * @export
 * @class PartnerApi
 * @extends {BaseAPI}
 */
export class PartnerApi extends BaseAPI implements PartnerApiInterface {
    /**
     * 
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public apiV1PartnerGemasPartnerIdGet(partnerId: string, options?: RawAxiosRequestConfig) {
        return PartnerApiFp(this.configuration).apiV1PartnerGemasPartnerIdGet(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public apiV1PartnerPartnerIdDelete(partnerId: number, options?: RawAxiosRequestConfig) {
        return PartnerApiFp(this.configuration).apiV1PartnerPartnerIdDelete(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public apiV1PartnerPost(body?: number, options?: RawAxiosRequestConfig) {
        return PartnerApiFp(this.configuration).apiV1PartnerPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PartnerByFilterRequest} [partnerByFilterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerApi
     */
    public apiV1PartnerSpecialcasesPost(partnerByFilterRequest?: PartnerByFilterRequest, options?: RawAxiosRequestConfig) {
        return PartnerApiFp(this.configuration).apiV1PartnerSpecialcasesPost(partnerByFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

